import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Project, ProjectTree } from '../../models/project';
import { ProjectService } from '../project.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateProjectModal } from '../create-projekt-modal/create-project-modal';
@Component({
  templateUrl: 'structure-tree.component.html',
  selector: 'cw-project-structure-tree'
})

export class ProjectStructureTreeComponent {
  @Input() root: ProjectTree;
  @Input() project: Project;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private projectService: ProjectService,
              private modal: NgbModal) {

  }

  showEditModal(project: Project) {
    const modalRef = this.modal.open(CreateProjectModal);

    modalRef.componentInstance.initExisting(project);
    modalRef.result.then((project) => {
      this.changed.emit(true);
    }, (reason) => {

    });
  }

  deleteProject(project: Project) {
    if (!confirm('Ta bort projektet?')) {
      return;
    }

    this.projectService.destroy(project).subscribe(() => {
      this.changed.emit(true);
    });
  }

  onChildrenChange() {
    this.changed.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/structure-tree/structure-tree.component.ts